module.exports = __webpack_public_path__ + "static/media/ev12.3b7d8e8b.jpg";